import { useEffect, useRef, useState } from "react";
import search from '../assets/blog/search.svg';
import views from '../assets/blog/views.svg';
import axios from "axios";
import featuredDefault from "../assets/blog/featuredDefault.svg";
import defaultImg from "../assets/blog/default.svg";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import Card from "../components/blog/card";
import ScheduleSession from "../components/blog/scheduleSession";

export default function Blogs() {
    const [searchText, setSearchText] = useState("");
    const [featured, setFeatured] = useState();
    const [latestBlogs, setLatestBlogs] = useState();
    const [shownBlogs, setShownBlogs] = useState([]);
    const [visibleCount, setVisibleCount] = useState(6);
    const [allBlogs, setAllBlogs] = useState([]);
    const [filteredBlogs, setFilteredBlogs] = useState([]);
    const [trendingTags, setTrendingTags] = useState([]);
    const [trendingBlogs, setTrendingBlogs] = useState([]);
    const uniqueVal = new Set();
    const navigate = useNavigate();
    const searchBarReff = useRef(null);

    useEffect(()=>{
        const fetchData = async () => {
            const [allBlogs, latestBlogs, popularBlogs, trendingBLogs] = await Promise.all([
                axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/blog`),
                axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/blog`, {params:{orderBy:"date", order:"desc"}}),
                axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/blog`, {params:{limit:"5",orderBy:"views",order:"desc"}}),
                axios.get(`${process.env.REACT_APP_BACKEND_BASE_URL_DEV}/blog/trending`),
            ]);

            setAllBlogs(allBlogs?.data);
            setFilteredBlogs(allBlogs?.data);
            setFeatured(latestBlogs?.data[0]);
            setLatestBlogs(latestBlogs);
            setTrendingBlogs(trendingBLogs?.data)
            setShownBlogs(latestBlogs?.data?.slice(0, visibleCount));

            popularBlogs.data.forEach((blog) => {
                blog?.attributes?.forEach((attr)=>{
                    uniqueVal.add(attr);
                });
            });
            setTrendingTags([...uniqueVal]);
        };

        fetchData();

    },[])


    useEffect(() => {
        setShownBlogs(latestBlogs?.data.slice(0, visibleCount));
    }, [visibleCount]);

    const filterFunction = async () => {
        const updatedBlogList = allBlogs.filter((blog) => {
            return blog.title.toLowerCase().includes(searchText.toLowerCase());
        });
        setFilteredBlogs(updatedBlogList);
    }

    useEffect(()=>{
        filterFunction();
    },[searchText]);

    useEffect(()=>{

    },[filteredBlogs])

    return (
        <div className="w-full relative font-primary ">

            {/* Main content */}
            <div className={"w-[85%] xl:w-[75%] mx-auto py-4 relative"}>
                <section>
                    <div className="flex w-full justify-between gap-3 py-4">
                        <p className="text-primary-color w-full sm:w-2/3 text-2xl text-nowrap sm:text-3xl font-medium	">
                            <span className="underline under underline-offset-8 decoration-primary-color">Featu</span>red Post
                        </p>
                        <div className="w-full sm:w-1/3 relative z-40 flex flex-col">
                            <div className="flex items-center justify-end relative w-full">
                                <input
                                    type="text"
                                    name="searchBar"
                                    ref={searchBarReff}
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                    className="rounded-lg relative w-10 sm:w-full bg-white px-3 py-1 border border-default-border placeholder-transparent sm:placeholder-gray-500 transition-all duration-500 focus:w-[100%] sm:focus:w-full"
                                    placeholder="Search..."
                                />
                                {!!searchText ? (
                                    <button 
                                        onClick={()=> {
                                            setSearchText("");
                                            searchBarReff.current.focus();
                                        }} 
                                        type="button" 
                                        className="w-6 h-6 z-30 bg-white absolute right-[8px] sm:right-[8px]"
                                    >
                                        <svg className="stroke-red-500" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M13 3L3 13M3 3L13 13"  stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </button>
                                ) : (
                                    <img 
                                        onClick={()=>{searchBarReff.current.focus()}} 
                                        src={search} alt="searchicon" 
                                        className="w-6 h-6 z-30 bg-white absolute right-[8px] sm:right-[8px]" 
                                    />
                                )}
                            </div>
                            {!!searchText && (
                                <div className="absolute top-9 z-40 w-full  bg-white rounded-lg shadow-lg">
                                    <div className="p-4 bg-gradient-to-r from-[#FF99000D] to-[#04236B0D]">
                                        <div className="flex flex-wrap gap-2">
                                            {
                                                trendingTags?.slice(0,6)?.map((tag)=>(
                                                    <div key={tag} className="flex w-auto rounded-full bg-primary-color text-white px-3 py-1">
                                                        # {tag}
                                                    </div>
                                                ))
                                            }
                                        </div>
                                        <div className="mt-4">
                                            <p className="text-[#999999]">Posts</p>
                                            <div className="flex flex-col gap-1 py-2">
                                                {/* Replace with filtered posts */}
                                                {
                                                    filteredBlogs?.slice(0,6)?.map((blog) => (
                                                        <p onClick={()=>navigate("/blogs/" + blog.id)} key={blog._id} className="w-full cursor-pointer line-clamp-1">
                                                            {blog.title}
                                                        </p>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                        <div className="flex justify-center items-center text-primary-color border-primary-color mt-4">
                                            <button
                                                onClick={() => navigate("/blogSearch")}
                                                type="button"
                                                className="px-6 py-1.5 border border-primary-color rounded-lg"
                                            >
                                                Show All
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Rest of the content */}
                    <div className="flex flex-col md:flex-row gap-5 w-full h-[55vh] sm:h-[75vh] py-3">
                        <div className="w-full flex-1 relative h-full md:w-2/3 rounded-lg bg-gradient-to-r from-[#FF99000D] to-[#04236B0D]">
                            <div className="h-1/2 w-full flex items-end justify-center">
                                {!!featured?.data?.coverImage ? (
                                    <div className="w-[75%] pt-8 h-full flex items-end object-contain">
                                        <img src={featured?.coverImage} alt="fleaturedimg" className="w-full max-h-full" />
                                    </div>
                                ) : (
                                    <div className="w-[75%] pt-8 h-full flex items-end object-contain">
                                        <img src={featuredDefault} alt="featuredimg" className="w-full max-h-full" />
                                    </div>
                                )}
                            </div>
                            <div className="h-1/2 overflow-hidden p-4 flex flex-col justify-between sm:justify-evenly">
                                <p className="font-semibold text-lg line-clamp-1">
                                    {featured?.title}
                                </p>
                                <div>
                                    <p>
                                        <span className="line-clamp-3 md:line-clamp-4 lg:line-clamp-5" dangerouslySetInnerHTML={{ __html: featured?.content[0]?.content }}>
                                        </span>
                                        <a href={"/blogs/" + featured?.data?._id} target="_self" className="text-secondary-color">
                                            Read more
                                        </a>
                                    </p>
                                </div>
                                <div className="flex justify-between">
                                    <div className="flex w-full gap-3 sm:gap-6 justify-start">
                                        <p className="text-primary-color text-nowrap">
                                            {featured?.createdBy}
                                        </p>
                                        <p className="text-[#999999] text-nowrap">
                                            {!!featured?.date && format(new Date(featured?.date), 'dd MMM, yyyy')}
                                        </p>
                                    </div>
                                    {/* <p className="text-[#999999] hidden sm:block text-nowrap">
                                        17 mins read
                                    </p> */}
                                </div>
                            </div>
                            <div className="flex text-[13 px] sm:text-base gap-1 absolute top-4 right-4 text-[#999999]">
                                <img src={views} alt="viewicon" className="w-4 h-4 sm:w-6 sm:h-6" />
                                <p>
                                    {featured?.views}
                                </p>
                            </div>
                        </div>
                        <div className="w-full h-full relative hidden overflow-hidden md:block md:w-1/3">
                            <div className="w-full h-full relative overflow-y-auto rounded-lg border-[0.5px] border-[#999999] p-4 sm:p-6 md:p-8">
                                {/* This one is for pc */}
                                <p className="text-2xl pb-2">Weekly Trending Post</p>
                                <div className="flex flex-col gap-3 w-full">
                                    {trendingBlogs?.map((blog) => (
                                        <article key={blog?._id || blog?.id || Math.random()} onClick={()=>navigate(`/blogs/${blog.id}`)} className="flex items-center cursor-pointer justify-center bg-gradient-to-r p-[1.5px] from-primary-color to-secondary-color w-full h-1/2 rounded-xl overflow-hidden bg-clip-border">
                                            <div className="bg-white rounded-[0.65rem] overflow-hidden w-full h-full border-[0.5px] border-[#999999]">
                                                <div className="w-full min-h-20 h-1/3 relative">
                                                    {!!blog.coverImage ? (
                                                        <div className="w-full h-full flex items-end object-cover">
                                                            <img src={blog.coverImage} alt="fleaturedimg" className="w-full min-h-full object-cover" />
                                                        </div>
                                                    ) : (
                                                        <div className="w-full h-full flex items-end object-cover">
                                                            <img src={defaultImg} alt="featuredimg" className="w-full h-full object-cover" />
                                                        </div>
                                                    )}
                                                    <p className="absolute line-clamp-1 top-2 left-2 text-white">
                                                        {blog?.title}
                                                    </p>
                                                </div>
                                                <div className="w-full h-[55%] p-2 flex flex-col justify-between">
                                                    <div className="flex w-full justify-between items-start">
                                                        <p className="font-semibold">
                                                            {blog.attributes[0]}
                                                        </p>
                                                        <div className="flex gap-1 text-[#999999] items-center">
                                                            <img src={views} alt="viewicon" className="w-5 h-5" />
                                                            <p>{blog.views}</p>
                                                        </div>
                                                    </div>
                                                    <p>1/1/1</p>
                                                    <div>
                                                        <p className="overflow-hidden whitespace-nowrap text-ellipsis w-[90%] line-clamp-2" dangerouslySetInnerHTML={{ __html: blog.content[0].content }}>
                                                        </p>
                                                        <a href={"/blogs/" + blog.id} target="_self" className="text-primary-color">
                                                            Read more
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </article>
                                    ))}
                                </div>
                            </div>
                            <div className="absolute m-[1px] bottom-0 left-0 right-0 h-6 bg-gradient-to-t from-gray-200 via-gray-200/50 backdrop-blur-sm backdrop-opacity-60 to-transparent pointer-events-none z-10" />

                        </div>
                    </div>
                </section>

                {/* Rest of the sections */}
                <section className="py-8">
                    <div className="flex justify-between pb-3">
                        <p className="text-primary-color font-medium	 text-2xl text-nowrap sm:text-3xl">
                            <span className="underline decoration-primary-color underline-offset-8">Late</span>st Topics
                        </p>
                        <button onClick={() => navigate("/blogSearch")} type="button" className="shadow-custom flex items-center text-white bg-primary-color border-[#999999] justify-center cursor-pointer rounded-lg py-1.5 px-4">
                            Show All
                        </button>
                    </div>
                    <div className="my-4 flex flex-nowrap overflow-x-auto justify-start items-center gap-4 sm:grid sm:grid-cols-2 lg:grid-cols-3 md:gap-5 xl:gap-7">
                        {shownBlogs?.map((item) => (
                            <Card key={item._id || item.id} id={item.id} image={item?.coverImage} tags={item.attributes} title={item.title} view={item.views} description={item.content[0]?.content} createdBy={item?.createdBy} date={item?.date} />
                        ))}
                    </div>
                    <div className="w-full hidden sm:flex text-center justify-center py-2 text-white">
                        {visibleCount < latestBlogs?.data?.length && (
                            <button onClick={() => setVisibleCount((prev) => prev + 9)} className="block bg-primary-color px-3 py-2 rounded-lg">
                                Load More
                            </button>
                        )}
                    </div>
                </section>
                <section className="block w-full sm:hidden">
                    <div className="flex justify-between items-center">
                        {/* Mobile Weekly Trending */}
                        <p className="text-lg font-semibold py-3">
                            Weekly Trending Post
                        </p>
                    </div>
                    <div className="flex w-full flex-col gap-4">
                        {trendingBlogs?.slice(0, 5)?.map((blog) => (
                            <article key={blog._id || blog.id} onClick={()=>navigate(`/blogs/${blog.id}`)} className="p-4 flex cursor-pointer flex-col gap-2 rounded-lg border-[0.5px] border-[#04236B1A]">
                                <p className="text-lg line-clamp-1">
                                    {blog.title}
                                </p>
                                <p className="text-[#999999] line-clamp-2" dangerouslySetInnerHTML={{ __html: blog.content[0].content }}>
                                </p>
                                <div className="flex justify-between items-center">
                                    <div className="rounded-full px-2.5 py-0.5 border-[0.2px] border-[#999999]">
                                        {blog.attributes[0]}
                                    </div>
                                    <div className="flex gap-1 text-[#999999]">
                                        <img src={views} className="w-6 h-6" alt="viewicon" />
                                        <p>
                                            {blog.views}
                                        </p>
                                    </div>
                                </div>
                            </article>
                        ))}
                    </div>
                </section>
                <div className="w-full py-8">
                    <ScheduleSession />
                </div>
            </div>

            {/* Blur overlay */}
            {searchText && (
                <div className="fixed backdrop-blur-sm top-0 left-0 w-screen h-screen bg-black bg-opacity-20 z-10"></div>
            )}
        </div>
    );
}